import ELK from "elkjs/lib/elk.bundled.js";                                                                                                                                                         
                                                                                                                                                                                                    
  const elk = new ELK();                                                                                                                                                                              
                                                                                                                                                                                                      
  const ELK_DIRECTION = {
    TB: "DOWN",
    BT: "UP",
    LR: "RIGHT",
    RL: "LEFT",
  };

  function buildLayoutOptions(options) {
    return {
      "elk.algorithm": "layered",
      "elk.direction": ELK_DIRECTION[options.direction] ?? "DOWN",

      // Spacing — same semantics as dagre's [nodesep, ranksep]
      "elk.spacing.nodeNode": String(options.spacing[0]),
      "elk.layered.spacing.nodeNodeBetweenLayers": String(options.spacing[1]),

      // Edge routing — the main reason to use ELK
      "elk.edgeRouting": "ORTHOGONAL",
      "elk.spacing.edgeNode": "80",
      "elk.spacing.edgeEdge": "80",
      "elk.layered.spacing.edgeNodeBetweenLayers": "40",
      "elk.layered.spacing.edgeEdgeBetweenLayers": "20",

      // Layout quality
      "elk.layered.nodePlacement.strategy": "NETWORK_SIMPLEX",
      "elk.layered.crossingMinimization.strategy": "LAYER_SWEEP",
      "elk.layered.thoroughness": "20",

      // Keep nodes balanced along the cross-axis
      "elk.layered.nodePlacement.bk.fixedAlignment": "BALANCED",
    };
  }

  const elkLayout = async (nodes, edges, options) => {
    if (nodes.length === 0) {
      return { nodes, edges };
    }

    const graph = {
      id: "root",
      layoutOptions: buildLayoutOptions(options),
      children: nodes.map((node) => ({
        id: node.id,
        width: node.measured?.width ?? 150,
        height: node.measured?.height ?? 50,
      })),
      edges: edges.map((edge) => ({
        id: edge.id,
        sources: [edge.source],
        targets: [edge.target],
      })),
    };

    const layoutedGraph = await elk.layout(graph);

    const layoutedById = new Map(
      (layoutedGraph.children ?? []).map((n) => [n.id, n]),
    );

    const nextNodes = nodes.map((node) => {
      const layoutedNode = layoutedById.get(node.id);
      return {
        ...node,
        position: {
          x: layoutedNode?.x ?? 0,
          y: layoutedNode?.y ?? 0,
        },
      };
    });

    return { nodes: nextNodes, edges };
  };

  export default elkLayout;